import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/home/vsts/work/1/s/src/components/ui/atoms/breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BurgerMenu"] */ "/home/vsts/work/1/s/src/components/ui/atoms/burger-menu/burger-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonResolver"] */ "/home/vsts/work/1/s/src/components/ui/atoms/button/Button.resolver.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoBackButton"] */ "/home/vsts/work/1/s/src/components/ui/atoms/go-back-button/GoBackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/vsts/work/1/s/src/components/ui/atoms/link/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextInput"] */ "/home/vsts/work/1/s/src/components/ui/atoms/text-input/TextInput.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleMenuIcon"] */ "/home/vsts/work/1/s/src/components/ui/atoms/toggler-menu-icon/ToggleMenuIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleShare"] */ "/home/vsts/work/1/s/src/components/ui/molecules/article-share/ArticleShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChipFilterList"] */ "/home/vsts/work/1/s/src/components/ui/molecules/chip-filter-list/ChipFilterList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyConverter"] */ "/home/vsts/work/1/s/src/components/ui/molecules/currency-converter/CurrencyConverter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/home/vsts/work/1/s/src/components/ui/molecules/pagination/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/home/vsts/work/1/s/src/components/ui/molecules/video/Video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardPartenaireList"] */ "/home/vsts/work/1/s/src/components/ui/organisms/cards/card-partenaire-list/CardPartenaireList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainNavigationMenu"] */ "/home/vsts/work/1/s/src/components/ui/organisms/main-navigation-menu/MainNavigationMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavHeader"] */ "/home/vsts/work/1/s/src/components/ui/organisms/nav-header/NavHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/components/WysiwygSimple.tsx");
